<!-- Бейдж «BETA» рядом с заголовком раздела, который ещё в бета-версии. -->
<template>
  <v-chip x-small label outlined color="primary" class="beta-chip ml-2" data-testid="beta-chip">
    {{ $t("common.beta") }}
  </v-chip>
</template>

<script>
export default {
  name: "BetaChip",
};
</script>

<style scoped>
.beta-chip {
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  vertical-align: middle;
}
</style>
